import { RemoteRemovePlaceFromGroup } from 'data/usecases';
import { RemovePlaceFromGroupUseCaseInterface } from 'domain/usecases';
import { makeApiUrlRemovePlaceFromGroup } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteRemovePlaceFromGroup =
  (): RemovePlaceFromGroupUseCaseInterface =>
    new RemoteRemovePlaceFromGroup(
      makeApiUrlRemovePlaceFromGroup(),
      makeAxiosHttpClient(),
    );
